export default "__VITE_ASSET__CKcBJQpF__"